import type { ThemeId } from "@smartvow/shared";
import { Card } from "../../shared/ui/index.js";
import { useToast } from "../../shared/toast.js";
import { ThemeSelect } from "./ThemeSelect.js";
import { useUpdateEventTheme } from "./events.api.js";

export function ThemePanel({ eventId, theme }: { eventId: string; theme: ThemeId }) {
  const update = useUpdateEventTheme(eventId);
  const toast = useToast();
  return (
    <Card id="theme">
      <h2 className="font-serif text-lg">Thème</h2>
      <p className="mt-1 text-sm text-stone-500">Applique les couleurs à la page invité.</p>
      <div className="mt-3">
        <ThemeSelect
          value={theme}
          onChange={(t) => update.mutate(t, { onSuccess: () => toast("Thème mis à jour") })}
        />
      </div>
    </Card>
  );
}
